import type { CMSImage } from 'types/AlgoliaResults';

export type SearchResultCard = {
  resultType: 'recipe' | 'product' | 'tipsAndTricks' | 'article';
  id: string;
  title: string;
  description?: string;
  categoryId?: string;
  category?: string;
  subCategory?: string;
  section?: string;
  images?: {
    desktop?: string;
    mobile?: string;
    hero?: string;
    tablet?: string;
    aiLabeling?: boolean;
  };
  information?: {
    preparationTime: string;
    rating: string;
    difficulty: string;
    totalTime: string;
  };
  video?: string | boolean;
  productsAmount?: string;
  button?: string;
  link?: {
    url: string;
    displayName: string;
  };
};
export const getRecipeImages = (
  images: { url: string; height: number; width: number }[],
): Record<string, string> => {
  const result: Record<string, string> = {};
  images.forEach((img) => {
    if (!img.url || img.height < 450) return;
    if (img.width > 1000) {
      result.desktop = img.url;
    }
    if (img.width < 1000) {
      result.mobile = img.url;
    }
  });
  return result;
};

export const getCMSImages = (images: CMSImage[] | undefined): Record<string, string> => {
  const result: Record<string, string> = {};
  if (!images) return {};
  images.forEach((img) => {
    if (img.width === 1440) {
      result.desktop = img.url;
    }
    if (img.width === 636) {
      result.mobile = img.url;
    }
  });
  return result;
};
